/**
 * @file 分類服務 API
 * @description 提供文章分類相關的 API 方法，包含分類列表、分類文章列表等功能
 */
import { get, post } from './sub_services/base';
import apiPath from './api.path';
import config from 'config/config';
import ExceptionHandleService from 'utils/exceptionHandler';

const _EHS = new ExceptionHandleService({
  _NAME: 'services/category.ts',
  _NOTICE: 'category api'
});

/** 取得分類文章列表請求參數介面 */
export interface GetCategoryPostListParams {
  categoryId: string;
  page?: number;
  pageSize?: number;
  [key: string]: unknown;
}

/** [GET]取得文章分類列表 */
const getCategoryList = async (params?: Record<string, unknown>): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.category.getCategoryList}`;
    const result = await get(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'getCategoryList', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

/** [POST]取得分類文章列表 */
const getCategoryPostList = async (params: GetCategoryPostListParams): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.category.getCategoryPostList}`;
    const result = await post(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'getCategoryPostList', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

export default {
  getCategoryList,
  getCategoryPostList
};
